import { useQuery } from '@tanstack/react-query';
import request from '@teetsh/app/src/utils/request';
import { useSchoolSchoolyear } from '@teetsh/app/src/containers/App/context/SchoolyearSchoolProvider';
import { format } from '@teetsh/app/src/utils/time/format';
import { deserializeAppel } from './serializer';
import {
  Appel,
  AppelType,
  DayAppels,
} from '@teetsh/app/src/containers/RegistreAppel/types/appel';
import { useUser } from '@teetsh/app/src/containers/App/context/useUser';
import { AxiosError } from 'axios';

export const APPELS_KEY = 'appels';

interface Props {
  date: Date;
  type: AppelType;
  select?: (v: DayAppels) => any;
  notifyOnChangeProps?: string[] | 'tracked';
}

function getAppelsBetweenDates({
  schoolyearId,
  schoolId,
  date,
  tz,
}: {
  schoolyearId: string;
  schoolId: string;
  date: Date;
  tz: string;
}) {
  const requestURL = `/schoolyears/${schoolyearId}/schools/${schoolId}/appels?date=${format(
    date,
    'fr-FR',
  )}`;
  return request(requestURL, {
    method: 'GET',
  }).then<DayAppels>(data => ({
    morning: data.morning && deserializeAppel(data.morning, tz),
    afternoon: data.afternoon && deserializeAppel(data.afternoon, tz),
  }));
}

export function useAppels<T = Appel | undefined>(props: Props) {
  const { date, select } = props;
  const user = useUser();
  const { schoolyear, school } = useSchoolSchoolyear();
  return useQuery<DayAppels, AxiosError, T>({
    queryKey: [schoolyear.id, school.id, APPELS_KEY, format(date, 'fr-FR')],
    queryFn: () =>
      getAppelsBetweenDates({
        schoolyearId: schoolyear.id,
        schoolId: school.id,
        date,
        tz: user.location,
      }),

    select: select || (data => data[props.type]),
    placeholderData: undefined,
    staleTime: 1000 * 60 * 60,
    notifyOnChangeProps: props.notifyOnChangeProps as any,
    refetchOnWindowFocus: false,
  });
}
